import snakeCase from 'lodash/snakeCase';

import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

export const triggerVehicleCardClickedEvent = (category: string, enquiryId: number): void => {
	const eventPayload = getSnowplowEventPayload({
		category,
		customData: { label: String(enquiryId) },
		name: `dlr_${snakeCase(category)}_vehicle_card_click`,
		schemaName: SNOWPLOW_EVENTS.CLICK.SCHEMA,
		version: SNOWPLOW_EVENTS.CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
